<template>
  <div>
    <overview-report v-if="!isSalesperson" />
    <!--    <module-progress-->
    <!--      :users="users"-->
    <!--      :spec_dealers="specificDealers"-->
    <!--      :modules="modules"-->
    <!--      :outstanding_modules="outstandingModules"-->
    <!--      :outstanding_playlists="outstandingPlaylists"-->
    <!--    ></module-progress>-->
    <progress-report></progress-report>
<!--    <team-progress-->
<!--      :users="users"-->
<!--      :spec_dealers="specificDealers"-->
<!--      :modules="modules"-->
<!--      :outstanding_modules="outstandingModules"-->
<!--      :outstanding_playlists="outstandingPlaylists"-->
<!--    ></team-progress>-->
  </div>
</template>
<script>
import { some as _some } from 'lodash-es';
import ModuleProgress from '../components/client-reports/ModuleProgress.vue';
import TeamProgress from '../components/client-reports/TeamProgress.vue';
import OverviewReport from '../components/client-reports/OverviewReport.vue';
import ProgressReport from '../components/client-reports/progress-report/ProgressReport.vue';

export default {
  name: 'ClientReport',

  components: {
    ModuleProgress,
    TeamProgress,
    OverviewReport,
    ProgressReport,
  },

  data: () => ({
    users: [],
    specificDealers: [],
    modules: [],
    outstandingModules: [],
    outstandingPlaylists: [],
  }),

  computed: {
    isSalesperson() {
      const roles = this.$auth.user().roles;
      return _some(roles, { name: 'salesperson' });
    },
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.fetchUsers();
      this.fetchDefModules();
      this.fetchspecificdealers();
      this.fetchOutstandingModules();
      this.fetchOutstandingPlaylists();
    },

    fetchUsers() {
      this.axios
        .post('/client/reports/fetchusers')
        .then(({ data }) => {
          this.users = data;
        })
        .catch((error) => {});
    },
    fetchspecificdealers() {
      this.axios
        .get('/client/reports/fetchspecificdealers')
        .then(({ data }) => {
          this.specificDealers = data;
        })
        .catch((error) => {});
    },
    fetchDefModules() {
      this.axios
        .get('/client/reports/fetchmodules')
        .then(({ data }) => {
          this.modules = data;
        })
        .catch((error) => {});
    },
    fetchOutstandingModules() {
      this.axios
        .get('/client/reports/fetchoutstandingmodules')
        .then(({ data }) => {
          this.outstandingModules = data;
        })
        .catch((error) => {});
    },
    fetchOutstandingPlaylists() {
      this.axios
        .get('/client/reports/fetchoutstandingplaylists')
        .then(({ data }) => {
          this.outstandingPlaylists = data;
        })
        .catch((error) => {});
    },
  },
};
</script>
